import { Controller } from "@hotwired/stimulus"

import TomSelect from "tom-select"
import { ingredientSearchResult } from "../src/ingredient_search_result"

export default class extends Controller {
  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    this.abortController = new AbortController()
    const signal = this.abortController.signal
    this.select = new TomSelect(this.element, {
      valueField: "id",
      labelField: "text",
      searchField: [],
      diacritics: true,
      preload: true,
      load(query, callback) {
        this.clearOptions()
        fetch(`/ingredients/search.json?search[term]=${encodeURIComponent(query)}`, { signal })
          .then(response => response.json())
          .then(json => { if (!signal.aborted) callback(json) })
          .catch(() => { if (!signal.aborted) callback() })
      },
      render: {
        option: item => ingredientSearchResult(item.text),
        item(item) {
          window.location.href = item.url
          return null
        }
      }
    })
  }

  disconnect() {
    this.teardown()
  }

  teardown() {
    this.abortController?.abort()
    this.select?.destroy()
    this.select = null
  }
}
